let BRResults = null;
let _PAGE = 1;
let CURR_ACTIVE_TYPE = null;
let CURR_OPEN_MOBILE_TYPES = [];
const filterPrefix = 'filter.v.option.';

const sortFacet = {
  name: "sort by",
  value: [
    { name: "title-asc", displayName: "Alphabetically, A-Z", field: "title", order: "asc", count: "" },
    { name: "title-desc", displayName: "Alphabetically, Z-A", field: "title", order: "desc", count: ""},
    { name: "price-asc", displayName: "Price, low to high", field: "price", order: "asc", count: ""},
    { name: "price-desc", displayName: "Price, high to low", field: "price", order: "desc", count: ""},
    { name: "publishedAt-asc", displayName: "Date, old to new", field: "publishedAt", order: "asc", count: ""},
    { name: "publishedAt-desc", displayName: "Date, new to old", field: "publishedAt", order: "desc", count: ""},
  ]
};


///////////////////////////////////////////////////
// Init on page load
///////////////////////////////////////////////////

getCollectionResults(COLLECTION_ID, 1, () => {
  // console.log('************* initial collection load')
  renderCollectionResults();
  renderFacets();
});

///////////////////////////////////////////////////
// Listen for custom loadmore event
///////////////////////////////////////////////////

document.addEventListener('loadmore', (event) => {
  //let page = event.detail.url.split('?page=')[1].split('&')[0];
  //console.log('loadmore page', page)
  setTimeout(() =>{
    //console.log('************* loadmore page', _PAGE)
    if(BRResults.response.numFound > _PAGE * PER_PAGE){
      //console.log('************* loading more', _PAGE)
      _PAGE++;
      getCollectionResults(COLLECTION_ID, _PAGE, () => {
        renderCollectionResults();
        // renderFacets();
      });
    }

  }, 1000)
});

///////////////////////////////////////////////////
// loadmore IntersectionObserver and dispatch custom loadmore event
///////////////////////////////////////////////////

let loadMoreTarget = document.getElementById('shopify-section-footer');
if(document.querySelector('#plp-no-scroll')){
  loadMoreTarget = document.getElementById('plp-no-scroll');
}

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // console.log('>>>>>>>>>>>>>> Load more triggered!');
      const loadmoreEvent = new CustomEvent('loadmore', {
        detail: {}
      });
      document.dispatchEvent(loadmoreEvent);
    }
  });
}, {
  //root: null, 
  rootMargin: '0px 0px 400px 0px',
  //threshold: 1.0
});

observer.observe(loadMoreTarget);


////////////////////////////////////
// Clear Button
////////////////////////////////////

document.querySelectorAll('facet-drawer .drawer__footer').forEach(drawFooter => {
  drawFooter.querySelector('facet-remove').remove();
  let clearButton = document.createElement('button');
  clearButton.classList.add('btn', 'btn--tertiary', 'body-1');
  clearButton.innerHTML = "CLEAR ALL";
  clearButton.addEventListener('click', e => {
    history.pushState({}, "", window.location.pathname);
    _PAGE = 1;
    getCollectionResults(COLLECTION_ID, 1, () => {
      renderCollectionResults();
      renderFacets();
    });

    if(drawFooter.parentNode.parentNode.classList.contains('mobile')){
      document.querySelector('.drawer--filter.mobile .drawer-close').click();
    }
  })
  drawFooter.insertAdjacentElement('afterbegin',clearButton);
})


////////////////////////////////////
// BEGIN FUNCTIONS
////////////////////////////////////

////////////////////////////////////
// getCollectionResults
////////////////////////////////////

function getCollectionResults(category, page, callback) {

  function randomId() {
    return String(Math.floor(1e12 + Math.random() * 9e12));
  }

  function getCookie(key) {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(c => c.startsWith(key + '='));
    return cookie ? cookie.split('=')[1] : null;
  }

  let _br_uid_2 = getCookie('_br_uid_2');

  if (_br_uid_2) {
    _br_uid_2 = decodeURIComponent(_br_uid_2);
  } else {
    _br_uid_2 = '';
  }


  // console.log('page', page) 
    //start: ((page * PER_PAGE) - PER_PAGE) + 1,
  let start = (page - 1) * PER_PAGE; 
  const params = new URLSearchParams({
    account_id: '8258',
    auth_key: 'hdrkqdeih5uyrcu6',
    domain_key: 'amiri',
    request_id: randomId(),
    _br_uid_2: _br_uid_2,
    url: window.location.href,
    request_type: 'search',
    search_type: 'category',
    q: category,
    fl: 'pid,title,price,url,tags,publishedAt',
    rows: PER_PAGE,
    start: start,
  });

  let paramArr = window.location.search.slice(1).split('&');

  let filterPrefix = 'filter.v.option.';

  let filtersArr = [];

  // console.log('paramArr', paramArr)
  paramArr.forEach(param => {
    if (param.includes(filterPrefix)) {
      let field = decodeURIComponent(param.split('=')[0].replace(filterPrefix, '')).replaceAll('+', ' ');
      let value = decodeURIComponent(param.split('=')[1]).replaceAll('+', ' ');
      filtersArr.push({ field: field, value: value })
      //console.log('field')
      //console.log(field)
    }

    if (param.includes('sort_by=')) {
      let sortField = param.split('=')[1].split('-')[0].replace('created','publishedAt');
      let sortOrder = param.split('=')[1].split('-')[1].replace('ascending', 'asc').replace('descending', 'desc');
      let allowedSortFields = ['title', 'price', 'publishedAt'];
      let allowedSortOrders = ['asc', 'desc'];
      // console.log('sortField',sortField)
      // console.log('sortOrder', sortOrder)
      if(allowedSortFields.includes(sortField) && allowedSortOrders.includes(sortOrder)){
        params.set('sort', `${sortField} ${sortOrder}`)
      }
    }
    
  });

  // console.log('filtersArr', filtersArr)

  filtersArr.forEach( pair => {
    params.append('fq', `${pair.field}: "${pair.value}"`)
  })

  // If this is the first query clear the product-grid.
  // This is for when either filters or sort is called and the product-grid still has
  // products in it

  if(start == 0){
    document.querySelector('#product-grid').innerHTML = '';
  };

  fetch(`http://core.dxpapi.com/api/v1/core/?${params}`)
  .then((res) => res.json())
  .then((result) => {
    console.log('bloomreach result', result)
    BRResults = result;

    const order = ["availableForSale", "sku_color", "colors", "sku_size", "sizes", "material"];
    BRResults.facet_counts.facets.sort(
      (a, b) => order.indexOf(a.name) - order.indexOf(b.name)
    );

    BRResults.facet_counts.facets.unshift(sortFacet);
    console.log('BRResults with sort',BRResults)
    callback();
    
  })
}


////////////////////////////////////
// renderCollectionResults
////////////////////////////////////

function renderCollectionResults() {
  if (BRResults && BRResults.response && BRResults.response.docs) {

    const products = [...BRResults.response.docs];
    const contentBlocksContainer = document.querySelector('#content-block-container');
    const contentBlocks = [...contentBlocksContainer.getElementsByTagName('li')];

    if(!filterSortIsActive() && _PAGE === 1){
      contentBlocks.forEach(li => {
        let position = li.dataset.position;
        products.splice(position, 0, { contentblock: true });
      })
    }

    products.forEach((product, index) => {
      if(product.hasOwnProperty('contentblock')){
        const li = document.querySelector('#content-block-container').querySelector(`li[data-position="${index}"]`);
        const liNode = li.cloneNode(true); 
        //contentBlocksContainer.querySelector(`li[data-position="${index}"]`).remove();
        document.querySelector('#product-grid').appendChild(liNode);
      } else {
        const li = document.createElement("li");
        li.className = 'grid__item';
        li.id = `pid-${product.pid}`;
        document.querySelector('#product-grid').appendChild(li);
      }
    });
    
    products.forEach((product, index) => {
      if(product.hasOwnProperty('contentblock')) return;
      const handle = product.url.split('/products/')[1];
      getProductCardHTMLByHandle(handle, product.pid, index);
    });

    function filterSortIsActive(){
      const params = new URLSearchParams(window.location.search);
      if(params.has('sort_by') || params.toString().includes('filter.v.option.')){
        return true;
      }
      return false;
    }
  }

  ////////////////////////////////////
  // getProductCardHTMLByHandle
  ////////////////////////////////////

  function getProductCardHTMLByHandle(handle, pid, position) {
    //console.log('handle', handle)
    let url = `${window.Shopify.routes.root}products/${handle}?view=productcard`;
    fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = responseText;
      if (responseText.indexOf('404 Not Found') == -1) {
        document.getElementById(`pid-${pid}`).innerHTML = html;
      } 
    });
  }
}

document.querySelectorAll('input[name="sort_by"]').forEach(radio => {
  radio.addEventListener('change', (e) => {
    // console.log(e.target.value);
  });
});


////////////////////////////////////
// renderFacets
// render facets and sort ui
////////////////////////////////////

function renderFacets(screen = 'desktop'){
  //const url = new URL(window.location);

  const urlFiltersArr = [];
  let paramArr = window.location.search.slice(1).split('&');
  let filterPrefix = 'filter.v.option.';
  let sortField = null;
  let sortOrder = null;

  paramArr.forEach(param => {
    if (param.includes(filterPrefix)) {
      //let field = decodeURIComponent(param.split('=')[0].replace(filterPrefix, '')).replaceAll('+', ' ');
      //let value = decodeURIComponent(param.split('=')[1]).replaceAll('+', ' ');
      let field = decodeURIComponent(param.split('=')[0]);
      let value = decodeURIComponent(param.split('=')[1]).replace('+', ' ');
      urlFiltersArr.push({ field: field, value: value })
      //console.log('field')
      //console.log(field)
    }

    if (param.includes('sort_by')) {
      sortField = param.split('=')[1].split('-')[0];
      sortOrder = param.split('=')[1].split('-')[1];
    }

  })

  let typesUl = document.createElement("ul"); 
  typesUl.classList.add('facet-filters__types-container')

  let filtersUl = document.createElement("ul"); 
  filtersUl.classList.add('facet-filters__filters-container')


  let containerMobile = null;
  if(document.getElementsByClassName('br-facets-form-mobile').length){
    containerMobile = document.getElementsByClassName('br-facets-form-mobile')[0];
  } else {
    containerMobile = document.createElement('form');
    containerMobile.classList.add('br-facets-form-mobile');
    containerMobile.id = 'br-facets-form-mobile';
    containerMobile.classList.add('facet-filters-form__mobile');
  }

  // remove any existing content
  containerMobile.innerHTML = '';


  ///////////////////////////////////////////////////
  // Filters
  ///////////////////////////////////////////////////

  BRResults.facet_counts.facets.forEach((facet, index) => {
    //console.log(facet.name)
    /*
    if(
      facet.name.toLowerCase() !== 'sizes' || 
      facet.name.toLowerCase() !== 'size' || 
      facet.name.toLowerCase() !== 'color' || 
      facet.name.toLowerCase() !== 'material' || 
      facet.name.toLowerCase() !== 'availability'
    ){
      return;
    }
    */
    ////////////////////////////////////
    // create type li and buttons
    ////////////////////////////////////

    let liTypeNew = document.createElement('li');
    liTypeNew.classList.add('facet-filters__type', 'link-styled--grey');
    liTypeNew.dataset.filter = facet.name;
    liTypeNew.setAttribute('aria-current', false);
    if(CURR_ACTIVE_TYPE == facet.name){
      liTypeNew.classList.add('active');
    }

    let liTypeSpan = document.createElement('span');
    liTypeSpan.classList.add('icon-active');
    liTypeSpan.setAttribute('aria-hidden', true);
    liTypeNew.appendChild(liTypeSpan);

    let liTypeButton = document.createElement('button');
    liTypeButton.classList.add('btn','btn--unstyled');
    liTypeButton.setAttribute('aria-controls',`Filter${facet.name}-${index}`);
    // if(facet.name.toLowerCase() == 'colors') {
    if(facet.name.toLowerCase() == 'sku_color') {
      liTypeButton.setAttribute('aria-controls',`FilterColor`);
    }
    liTypeButton.innerText = formatFacetName(facet.name); 
    liTypeButton.addEventListener('click', handleTypeClick);
    liTypeNew.appendChild(liTypeButton);

    typesUl.appendChild(liTypeNew);


    ////////////////////////////////////
    // create filter li
    ////////////////////////////////////

    //console.log('liFilterSource',liFilterSource)

    let liFilterNew = document.createElement('li');
    liFilterNew.classList.add('facet-filters__filter');
    liFilterNew.dataset.index = index; 
    liFilterNew.dataset.filter = facet.name; 
    if(CURR_ACTIVE_TYPE == facet.name){
      liFilterNew.style.display = 'block';
    } else {
      liFilterNew.style.display = '';
    }

    let liFilterFieldset = document.createElement('fieldset');

    let liFilterFieldsetLegend = document.createElement('legend');
    liFilterFieldsetLegend.classList.add('visually-hidden');
    liFilterFieldsetLegend.innerText = `Filter by ${facet.name}`

    liFilterFieldset.appendChild(liFilterFieldsetLegend)

    let liFilterFieldsetUl = document.createElement('ul');
    liFilterFieldsetUl.id = `Filter${facet.name}-${index}`;
    if(facet.name.toLowerCase() == 'sku_color') {
    //if(facet.name.toLowerCase() == 'colors') {
      liFilterFieldsetUl.id = `FilterColor`;
    }


    ////////////////////////////////////
    // Start Mobile Type Details / Accordion
    ////////////////////////////////////

    let mobileTypeDiv = document.createElement('div');
    mobileTypeDiv.classList.add('details', 'filter__item');
    mobileTypeDiv.dataset.index = index;

    if(CURR_OPEN_MOBILE_TYPES.includes(facet.name)){
     mobileTypeDiv.classList.add('details--active'); 
    }

    let mobileTypeButton = document.createElement('button');
    mobileTypeButton.classList.add('btn', 'btn--unstyled', 'summary', 'facets__summary', 'content--full-width', 'flex', 'jcb', 'aic');
    mobileTypeButton.innerHTML = `
      <span>${formatFacetName(facet.name)}
        <span class="active-filters-size__split" style="display: none;"> / </span>
        <span class="active-filters-size" style="display: none;"></span>
      </span> 
      <svg class="icon icon--caret" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> 
        <path d="M0.666585 4L7.99992 12L15.3333 4" stroke="black"></path> 
      </svg> 
    `;
    mobileTypeButton.dataset.filterName = facet.name;

    mobileTypeButton.addEventListener('click', e => {
      e.preventDefault();
      if(CURR_OPEN_MOBILE_TYPES.includes(facet.name)){
        mobileTypeButton.parentNode.classList.remove('details--active');
        const i = CURR_OPEN_MOBILE_TYPES.indexOf(facet.name);
        if (i !== -1) CURR_OPEN_MOBILE_TYPES.splice(i, 1);
      } else {
        CURR_OPEN_MOBILE_TYPES.push(facet.name);
        mobileTypeButton.parentNode.classList.add('details--active');
      }
      //mobileTypeButton.parentNode.classList.toggle('details--active');
    })

    let mobileDetailsContentDiv = document.createElement('div');
    mobileDetailsContentDiv.classList.add('details__content');

    let mobileDetailsContentUl = document.createElement('ul');

    mobileDetailsContentUl.classList.add(facet.name.toLowerCase().replace(' ', '_'))
    mobileDetailsContentUl.classList.add('availability', 'list-unstyled', 'details__content-inner')

    ////////////////////////////////////
    // End Mobile Type Details / Accordion
    ////////////////////////////////////


    ////////////////////////////////////
    // create li filter options
    ////////////////////////////////////

    facet.value.forEach((value, valueIndex) => {

      ////////////////////////////////////
      // create li for input + label
      ////////////////////////////////////
      
      let li = document.createElement("li");
      li.classList.add('facet-filters__filter-item', 'facet-filters__is-filter', 'link-styled--grey', 'container');
      li.dataset.filter = facet.name;

      let liMobile = li.cloneNode(true); 

      ////////////////////////////////////
      // create Input
      ////////////////////////////////////
      let input = document.createElement("input");
      input.classList.add('facets__checkbox');
      input.type = "checkbox";
      input.checked = urlFiltersArr.some( filter => filter.field == `${filterPrefix}${facet.name}` && filter.value == value.name );
      if(facet.name.includes('sort')){
        if(value.name == `${sortField}-${sortOrder}`){
          input.checked = true;
        }
      }
      input.value = value.name;
      input.id = `Filter-${facet.name}-${valueIndex}`;
      let inputName = `${filterPrefix}${facet.name}`;
      if(facet.name.includes('sort')){
        inputName = `sort_by`;
      }
      input.name = inputName;

      let inputMobile = input.cloneNode(true); 
      inputMobile.id = `MobileFilter-${facet.name}-${valueIndex}`

      input.addEventListener('change', handleSortFilterInputChange);
      inputMobile.addEventListener('change', handleSortFilterInputChange);

      ////////////////////////////////////
      // create Label
      ////////////////////////////////////
      let label = document.createElement("label");
      label.classList.add('facets__label', 'container', 'body-2');
      label.setAttribute('for', `Filter-${facet.name}-${valueIndex}`);
      let labelName = formatLabelName(facet, value);

      let labelMobile = label.cloneNode(true); 

      //if(facet.name.toLowerCase() != "colors"){
      if(facet.name.toLowerCase() != "sku_color"){
        label.innerHTML = `
        <span class="icon-active" aria-hidden=""></span>
        <span>${labelName}</span>
        <span class="visually-hidden" aria-hidden="true">${value.name} (${value.count})</span>`;
      } else {
        label.classList.add('swatch-wrapper');
        let hex = "#fff";
        let colorObj = colorSwatchConfig.find(obj => obj.name.toLowerCase() == value.name.toLowerCase() );
        if(colorObj){
          hex = colorObj.value;
        }
        label.innerHTML = `
        <span class="swatch" style="background-color: ${hex}"></span> 
        <span role="tooltip" class="tooltip" aria-hidden="true">${labelName}</span> 
        <span class="visually-hidden" aria-hidden="true">${labelName} (${value.count})</span>`;
      }

      labelMobile.innerHTML = `
      <span class="icon-active" aria-hidden=""></span>
      <span>${labelName}</span>
      <span class="visually-hidden" aria-hidden="true">${value.name} (${value.count})</span>`;

      labelMobile.setAttribute('for', `MobileFilter-${facet.name}-${valueIndex}`);

      li.appendChild(input)
      li.appendChild(label)
      liFilterFieldsetUl.appendChild(li)

      liMobile.appendChild(inputMobile)
      liMobile.appendChild(labelMobile)
      mobileDetailsContentUl.appendChild(liMobile)
      //liFilterFieldsetUl.appendChild(li)

    }) // end forEach facet.value

    liFilterFieldset.appendChild(liFilterFieldsetUl);
    liFilterNew.appendChild(liFilterFieldset);
    filtersUl.appendChild(liFilterNew);

    //mobileDetailsContentUl.appendChild(liMobile);
    mobileDetailsContentDiv.appendChild(mobileDetailsContentUl);

    mobileTypeDiv.appendChild(mobileTypeButton);
    mobileTypeDiv.appendChild(mobileDetailsContentDiv);
    containerMobile.appendChild(mobileTypeDiv);

  })
  if(document.getElementsByTagName('facet-drawer')[0].getElementsByTagName('facet-filters-form').length){
    document.getElementsByTagName('facet-drawer')[0].getElementsByTagName('facet-filters-form')[0].remove();
  }
  //if(document.getElementsByClassName('br-facets').length){
    //document.getElementsByClassName('br-facets')[0].remove();
  //}
  let container = null;
  if(document.getElementsByClassName('br-facets-form').length){
    container = document.getElementsByClassName('br-facets-form')[0];
  } else {
    container = document.createElement('form');
    container.classList.add('br-facets-form');
    container.id = 'br-facets-form';
  }

  // remove any existing uls
  [...container.getElementsByTagName('ul')].forEach( ul => { ul.remove() });
  container.appendChild(typesUl);
  container.appendChild(filtersUl);
  document.getElementsByTagName('facet-drawer')[0].getElementsByClassName('drawer__body')[0].appendChild(container);

  if(document.getElementsByTagName('facet-drawer')[1].getElementsByTagName('facet-filters-form-mobile').length){
    document.getElementsByTagName('facet-drawer')[1].getElementsByTagName('facet-filters-form-mobile')[0].remove();
  }
  //[...containerMobile.getElementsByTagName('ul')].forEach( ul => { ul.remove() });
  //containerMobile.appendChild(mobileTypeDiv);
  document.getElementsByTagName('facet-drawer')[1].getElementsByClassName('drawer__body')[0].appendChild(containerMobile);

  updateActiveFilters();



  ////////////////////////////////////
  // renderFacets functions
  ////////////////////////////////////


  ////////////////////////////////////
  // updateActiveFilters
  ////////////////////////////////////

  function updateActiveFilters() {
    let filtersArr = [];
    let paramArr = window.location.search.slice(1).split('&');
    let filterPrefix = 'filter.v.option.';

    paramArr.forEach(param => {
      if (param.includes(filterPrefix)) {
        let field = decodeURIComponent(param.split('=')[0].replace(filterPrefix, '')).replaceAll('+', ' ');
        let value = decodeURIComponent(param.split('=')[1]).replaceAll('+', ' ');
        filtersArr.push({ field: field, value: value })
      }
    })
    const filtersFormattedArr = Object.values(
      filtersArr.reduce((acc, { field, value }) => {
        if (!acc[field]) {
          acc[field] = { field, values: [] };
        }
        acc[field].values.push(value);
        return acc;
      }, {})
    );

    // Desktop update number of active filters on each type
    [...document.getElementsByClassName('facet-filters__type')].forEach( li => {
      //console.log('li.dataset.filter',li.dataset.filter)
      let found = filtersFormattedArr.find(obj => obj.field == li.dataset.filter);
      if(found) {

        // console.log('found')
        li.getElementsByTagName('button')[0].innerHTML = `
        ${formatFacetName(li.dataset.filter)}
        <span class="active-filters-size__split" style="display: inline;">/ </span>
        <span class="active-filters-size" style="display: inline;">${found.values.length}</span>
        `;
      } else {
        li.getElementsByTagName('button')[0].innerHTML = `${formatFacetName(li.dataset.filter)}`;
      }
    })

    // Mobile update number of active filters on each type
    document.querySelectorAll('.br-facets-form-mobile .filter__item').forEach( div => {
      //console.log('div', div)
      //console.log('li.dataset.filter',li.dataset.filter)
      let button = div.querySelector('button');
      let filterName = button.dataset.filterName; 
      let found = filtersFormattedArr.find(obj => obj.field == filterName);
      //console.log(filterName)
      //console.log(found)
      if(found) {
        // console.log('found')
        button.querySelector('.active-filters-size__split').style.display = 'inline';
        button.querySelector('.active-filters-size').style.display = 'inline';
        button.querySelector('.active-filters-size').innerHTML = found.values.length;
      } else {
        button.querySelector('.active-filters-size__split').style.display = 'none';
        button.querySelector('.active-filters-size').style.display = 'none';
        button.querySelector('.active-filters-size').innerHTML = '';
      }
    })

  }

  ////////////////////////////////////
  // handleSortFilterInputChange
  ////////////////////////////////////

  function handleSortFilterInputChange(e){
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    // console.log('e.target>>>>>>>>>>>>>>')
    // console.log(e.target)
    if(e.target.checked){
      if(e.target.name == 'sort_by'){
        params.delete('sort_by')
      }
      if(!params.has(e.target.name, e.target.value)){
        params.append(e.target.name, e.target.value);
      }
    } else {
      if(params.has(e.target.name, e.target.value)){
        params.delete(e.target.name, e.target.value);
      }
    }

    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : "");

    history.pushState({}, "", newUrl);

    CURR_ACTIVE_TYPE = e.target.name.replace(filterPrefix,'').replace('sort_by','sort by');

    getCollectionResults(COLLECTION_ID, 1, () => {
      // console.log('********** filter click load')
      _PAGE = 1;
      renderCollectionResults();
      renderFacets();
      CURR_ACTIVE_TYPE = null;
    });
    updateActiveFilters();
  }


  ////////////////////////////////////
  // handleTypeClick
  ////////////////////////////////////

  function handleTypeClick(e){
    e.preventDefault();
    // reset 
    [...document.getElementsByClassName('facet-filters__type')].forEach( li => {
      li.setAttribute('aria-current', false);
      li.classList.remove('active');
    });
    [...document.getElementsByClassName('facet-filters__filter')].forEach( li => {
      li.setAttribute('aria-expanded', false);
      li.style.display = 'none';
    });

    const liType = e.target.parentNode; 
    liType.setAttribute('aria-current', true);
    liType.classList.add('active');

    //console.log('liFilters', document.getElementById(`Filter${facet.name}-${index}`))

    let id = e.target.getAttribute('aria-controls');

    const liFilters = document.getElementById(id).parentNode.parentNode;
    liFilters.setAttribute('aria-expanded', true);
    liFilters.style.display = 'block';
  }

  ////////////////////////////////////
  // formatFacetName
  ////////////////////////////////////

  function formatFacetName(facetName){
    if(facetName.toLowerCase() == 'availableforsale'){
      return 'Availability';
    }
    if(facetName.toLowerCase() == 'sizes'){
      return 'Size';
    }
    if(facetName.toLowerCase() == 'sku_color'){
      return 'colors';
    }
    if(facetName.toLowerCase() == 'sku_size'){
      return 'Size';
    }
    facetName = facetName.replace('_',' ');
    return facetName;
  }

  ////////////////////////////////////
  // formatLabelName
  ////////////////////////////////////

  function formatLabelName(facet, value){
    // label name customizations
    if(facet.name.includes('sort')){
      return value.displayName;
    }
    if(facet.name == 'availableForSale' && value.name == 'true'  ){
      return 'IN STOCK'
    }
    if(facet.name == 'availableForSale' && value.name == 'false'  ){
      return 'OUT OF STOCK'
    }
    return value.name
  }
}
